export default __webpack_public_path__ + "static/media/Micropumps and Controlled Loop.af3ac874.png";